import configureAppStore from './configureStore';

const store = configureAppStore();

export default store;

export type AppDispatch = typeof store.dispatch

